/**
 * 应用卡片分享
 */
import React, { useCallback, useMemo } from "react";
import { ChatMessage, SessionType } from "@/types/chat";
import { MessageSendType } from "@/types/chat/enum";
import lodashGet from "lodash/get";
import "./index.less";
import IconFont from "@/components/icon";
import ChatState from "@/types/chat/State";
import { connect } from "dvajs";
import { buildTextMessageBody, initChatMessageInfo } from "@/utils/chat/message";

interface IProps {
  message: any;
  sessionType: SessionType;
  sendType: MessageSendType;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
  clsName?: string;
  showFooter?: boolean;
  pushChatMessage: Function;
}

function ShareHintCard(props: IProps & ChatState) {
  const { message, selectedSession, currentEmployee, pushChatMessage } = props;
  const dataInfo = lodashGet(message, "data.0", {});

  // 直接发送
  const handleClick = useCallback(
    (data: any) => {
      const textMsg = buildTextMessageBody(data.type, [], message.atUsers || [], undefined);
      const msgBody = initChatMessageInfo({
        selectedSession,
        currentEmployee,
        message: {
          ...textMsg,
          question: data.type,
          isMyself: true,
          ifIntent: true,
          intention_type: data.knowledgeBaseId
        } as any
      });
      pushChatMessage({ sessionId: selectedSession.sessionId, message: msgBody });
    },
    [currentEmployee, message.atUsers, pushChatMessage, selectedSession]
  );

  return (
    <div className="share-hint-item" onClick={() => handleClick(dataInfo)}>
      <IconFont className="share-hint-item_img" type={dataInfo.icon} />
      <div className="share-hint-item_right">{dataInfo.type}</div>
    </div>
  );
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  const { currentEmployee, selectedSession } = chat;
  return {
    currentEmployee,
    selectedSession
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    pushChatMessage(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareHintCard);
